import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";

/* 2021.10update: setting拆分开，可以只引用function */
import Vue from 'vue';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';
export function checkEndTime() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$now = _ref.now,
      now = _ref$now === void 0 ? Date.now() : _ref$now;

  var setting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.timeSetting;
  var 活动截止时间 = setting.活动截止时间,
      提示 = setting.提示,
      按钮文案 = setting.按钮文案,
      链接 = setting.链接;

  if (now > 活动截止时间 && 活动截止时间) {
    Vue.use(dialogPlugin);
    Vue.prototype.alert({
      msg: 提示 || '活动已经结束啦',
      confirmText: 按钮文案 || '前往福利社',
      confirm: function confirm() {
        window.location.href = 链接 || 'https://film.qq.com/x/welfare/';
      }
    });
  }
}